import { cn } from "@racoon/ui";
import { isValidElement, ReactNode } from "react";

export const InfoRow = ({
  label,
  value,
  shouldWrap = true,
}: {
  label: string;
  value: ReactNode;
  shouldWrap?: boolean;
}) => {
  const isValueElement = isValidElement(value);

  return (
    <div
      className={cn(
        "flex items-center text-sm font-normal leading-[14px] tracking-tight justify-between p-4 gap-2",
        shouldWrap && "flex-wrap",
      )}
    >
      <p className={cn("text-text-secondary", !shouldWrap && "flex-1 text-left")}>{label}</p>
      {isValueElement ? (
        value
      ) : (
        <p className={cn("text-text-primary", !shouldWrap && "flex-1 text-right")}>{value}</p>
      )}
    </div>
  );
};
